export enum USER_ROLES {
  ICT = 100,
  ADMIN = 101,
  TREASURY = 102,
  ALTERNATIVE_CHANNEL = 103,
  BDM = 104,
  GENERAL_MERCHANT = 200,
  DISTIBUTOR = 210,
  NATIONAL_RETAILER = 220,
  ONLINE_RETAILER = 230,
  AUH = 300,
  AUM = 301,
  HBA = 302,
  AIA = 310,
  EMPLOYEE = 311,
  BROKER = 400,
  OTHER_SYSTEM = 500,
  SALES = 501
};
